'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconHeaderContainer = exports.CardTitle = exports.CardContainer = undefined;
var _templateObject = _taggedTemplateLiteral(['\n  width: ', ';\n  padding: ', ';\n  margin-bottom: .5rem;\n\n  -webkit-box-shadow: 1px 0px 5px ', ';\n  -moz-box-shadow: 1px 0px 5px ', ';\n  box-shadow: 1px 0px 5px ', ';\n'], ['\n  width: ', ';\n  padding: ', ';\n  margin-bottom: .5rem;\n\n  -webkit-box-shadow: 1px 0px 5px ', ';\n  -moz-box-shadow: 1px 0px 5px ', ';\n  box-shadow: 1px 0px 5px ', ';\n']),
  _templateObject2 = _taggedTemplateLiteral(['\n  display: flex;\n  text-transform: uppercase;\n  font-size: 1rem;\n  color: ', ';\n\n  & > span {\n    align-self: center;\n  }\n'], ['\n  display: flex;\n  text-transform: uppercase;\n  font-size: 1rem;\n  color: ', ';\n\n  & > span {\n    align-self: center;\n  }\n']),
  _templateObject3 = _taggedTemplateLiteral(['\n  margin: .2rem;\n\n  & > svg {\n    width: 1rem;\n  }\n'], ['\n  margin: .2rem;\n\n  & > svg {\n    width: 1rem;\n  }\n']);
var _styledComponents = require('styled-components');
var _styledComponents2 = _interopRequireDefault(_styledComponents);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
var CardContainer = exports.CardContainer = _styledComponents2.default.div(_templateObject, function (props) {
  return props.width || '100%';
}, function (props) {
  return props.padding ? props.padding : '1rem';
}, function (props) {
  return props.theme['color_pastel-gray'];
}, function (props) {
  return props.theme['color_pastel-gray'];
}, function (props) {
  return props.theme['color_pastel-gray'];
});
var CardTitle = exports.CardTitle = _styledComponents2.default.h5(_templateObject2, function (props) {
  return props.theme.color_light_blue;
});
var IconHeaderContainer = exports.IconHeaderContainer = _styledComponents2.default.div(_templateObject3);